import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import WidgetComponent from "./WidgetComponent";
import useActivityWidget from "../../hooks/useActivityWidget";

dayjs?.extend(customParseFormat);

const ActivityWidget = ({ floating, widgetpos }) => {
  const {
    widgetConfig,
    buttonText,
    isOpenWidget,
    openWidget,
    langLoading,
    widgetLoading,
    setOpenWidget,
    dispatch,
    theme,
    send,
    getWidgetPositionStyle,
    activityLoading,
    loading,
  } = useActivityWidget();

  const hasImage            = Boolean(widgetConfig?.settings?.imageFileName?.trim());
  const configuredImgHeight = widgetConfig?.settings?.imageHeight;
  const [dynamicHeight, setDynamicHeight] = useState(undefined);

  const handleHeightChange = (heightPx) => {
    if (!hasImage) setDynamicHeight(heightPx);
  };

  const iframeHeight = hasImage
    ? configuredImgHeight ? `${configuredImgHeight}px` : "100vh"
    : dynamicHeight ?? "100vh";

  const activityData = {
    widgetConfig,
    buttonText,
    isOpenWidget,
    openWidget,
    langLoading,
    widgetLoading,
    setOpenWidget,
    dispatch,
    theme,
    send,
    getWidgetPositionStyle,
    activityLoading,
    loading,
    widgetpos,
  };

  if (widgetLoading || langLoading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={widgetLoading || langLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (widgetConfig?.settings?.kioskMode) {
    return (
      <Box sx={{ width: "100%", minHeight: "100vh" }}>
        <WidgetComponent
          activityData={activityData}
          heightChange={handleHeightChange}
          handleClose={() => setOpenWidget((prev) => !prev)}
        />
      </Box>
    );
  }

  return (
    <>
      {send(iframeHeight, "100vw", "", "0px", "0px", "", widgetConfig?.settings?.floatButtonActive)}
      <Box
        sx={{
          width: "100%",
          height: iframeHeight,
          position: "relative",
          overflow: "visible",
        }}
      >
        <WidgetComponent
          activityData={activityData}
          heightChange={handleHeightChange}
          handleClose={() => setOpenWidget((prev) => !prev)}
        />
      </Box>
    </>
  );
};

export default ActivityWidget;